/* eslint-disable @typescript-eslint/no-explicit-any */
import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {IProduct, IProductAttribute} from '@app/shared/models/product.model';
import {environment} from '@environments/environment';
import {map, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NewOrderService {
  private readonly _httpClient = inject(HttpClient);

  private readonly getProductsUrl = `${environment.api.baseUrl}/${environment.api.checkout.getProducts}`;
  private readonly getProductByIdUrl = `${environment.api.baseUrl}/${environment.api.checkout.getProductById}`;

  getProductById(productId: number, organizationId: number, productStatus: number): Observable<IProduct[]> {
    const params = new HttpParams();
    params.set('productId', productId);
    params.set('organizationId', organizationId);
    params.set('status', productStatus);
    return this._httpClient
      .get<IProduct>(
        `${this.getProductByIdUrl}/${productId}?organizationId=${organizationId}&status=${productStatus}`,
        {params}
      )
      .pipe(
        map(selectedProduct => {
          return [selectedProduct]?.map(product => {
            return {
              ...product,
              productWithAttributes: this.buildNestedProductAttributes(product.productWithAttributes, 0),
            };
          });
        })
      );
  }

  getProduct(organizationId: number, productStatus: number): Observable<IProduct[]> {
    const params = new HttpParams();
    params.set('status', productStatus);
    return this._httpClient.get<IProduct[]>(`${this.getProductsUrl}/${organizationId}`, {params}).pipe(
      map(products => {
        return products?.map(product => {
          return {
            ...product,
            productWithAttributes: this.buildNestedProductAttributes(product.productWithAttributes, 0),
          };
        });
      })
    );
  }

  // Function to convert flat product attributes array to nested structure
  buildNestedProductAttributes(attributes: IProductAttribute[], parentId: number): IProductAttribute[] {
    const nestedAttributes: IProductAttribute[] = [];
    attributes?.forEach(attribute => {
      if (attribute.parentAttributeId === parentId) {
        const nestedAttribute: IProductAttribute = {
          id: attribute.id,
          productId: attribute.productId,
          code: attribute.code,
          name: attribute.name,
          description: attribute.description,
          groupName: attribute.groupName,
          isActive: attribute.isActive,
          parentAttributeId: attribute.parentAttributeId,
          displayOrder: attribute.displayOrder,
          noGenes: attribute.noGenes,
          geneContent: attribute.geneContent,
          created: attribute.created,
        } as IProductAttribute;

        const childAttributes = this.buildNestedProductAttributes(attributes, attribute.id);
        if (childAttributes.length > 0) {
          nestedAttribute.productWithAttributes = [...childAttributes].sort(
            (cha, chb) => cha.displayOrder - chb.displayOrder
          );
        }

        nestedAttributes.push(nestedAttribute);
      }
    });

    return nestedAttributes.sort((nta, ntb) => nta.displayOrder - ntb.displayOrder);
  }
}
